module.exports = __webpack_public_path__ + "img/4a.fd0b5e1e.jpg";